import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/ilustrations/conectar-conta.gif'
import _imports_2 from '@/assets/ilustrations/login.gif'
import _imports_3 from '@/assets/ilustrations/criar-conta.gif'
import _imports_4 from '@/assets/ilustrations/conta-anonima.gif'


const _withScopeId = n => (_pushScopeId("data-v-7c876ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mainView"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "128",
    width: "128",
    alt: "Ícone de sacola com frutas e legumes."
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "Entre na sua conta"),
  /*#__PURE__*/_createElementVNode("p", null, "Selecione uma das opções de entrada abaixo para continuar.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ou teste sem fazer login:", -1))
const _hoisted_4 = {
  key: 2,
  class: "loginView"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  height: "256",
  width: "256",
  alt: "Desenho de duas pessoas conectando blocos de quebra-cabeça."
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Conecte a sua conta!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Você pode conectar a sua conta do Google para criar uma conta do tipo permanente. Contas permanentes tem acesso a mais funções, como a sincronização entre dispositivos!", -1))
const _hoisted_8 = {
  key: 3,
  class: "loginView"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  height: "256",
  width: "256",
  alt: "Desenho de uma pessoa conferindo uma longa lista de compras."
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Faça login", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Insira as informações da sua conta para entrar.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Senha", -1))
const _hoisted_14 = {
  key: 4,
  class: "loginView"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  height: "256",
  width: "256",
  alt: "Desenho de uma pessoa inserindo suas informações em um telefone."
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Crie sua conta!", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Insira um e-mail e senha para criar uma conta do tipo permanente. Contas permanentes tem acesso a mais funções, como a sincronização entre dispositivos!", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Senha", -1))
const _hoisted_21 = {
  key: 5,
  class: "loginView"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  height: "256",
  width: "256",
  alt: "Desenho de uma pessoa criativa, com várias ideias projetadas em seus pensamentos."
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Vamos começar!", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Com uma conta anônima, você pode testar a aplicação por um tempo limitado antes de decidir criar uma conta permanente.", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Você pode não ter acesso a determinados recursos que requerem uma conta permanente, como a sincronização entre dispositivos.", -1))
const _hoisted_26 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_HeaderNoti = _resolveComponent("HeaderNoti")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showView === 'Main')
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_LoginButton, {
              "button-title": 'Continuar com Google',
              "icon-title": 'PhGoogleLogo',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showView = 'ThirdyParties'))
            }),
            _createVNode(_component_LoginButton, {
              "button-title": 'Continuar com e-mail',
              "icon-title": 'PhEnvelope',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showView = 'EmailLogin'))
            }),
            _createElementVNode("div", null, [
              _hoisted_3,
              _createVNode(_component_LoginButton, {
                class: "secondary_login",
                "button-title": 'Continuar anônimo',
                "icon-title": 'PhDetective',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showView = 'Anonymous'))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showView !== 'Main')
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 1,
          "header-type": 'Secondary',
          "header-title": _ctx.headerTitle,
          onGoBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showView = 'Main'))
        }, {
          notification: _withCtx(() => [
            (_ctx.headerNotiText !== '')
              ? (_openBlock(), _createBlock(_component_HeaderNoti, {
                  key: 0,
                  "notification-icon": _ctx.headerNotiIcon,
                  "notification-text": _ctx.headerNotiText
                }, null, 8, ["notification-icon", "notification-text"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header-title"]))
      : _createCommentVNode("", true),
    (_ctx.showView === 'ThirdyParties')
      ? (_openBlock(), _createElementBlock("main", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_Button, {
            disabled: _ctx.userActionButton,
            "button-text": 'Concetar conta',
            "has-icon": 'No',
            onClick: _ctx.googleLogin
          }, null, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showView === 'EmailLogin')
      ? (_openBlock(), _createElementBlock("main", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("form", {
            class: "emailCredentials",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emailSingIn && _ctx.emailSingIn(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                placeholder: "email@exemplo.com",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userEmail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userEmail]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                id: "password",
                type: "password",
                placeholder: "********",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userPassword]
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                disabled: _ctx.userActionButton,
                type: "button",
                "button-text": 'Criar conta',
                "button-type": 'Secondary',
                "has-icon": 'No',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showView = 'EmailSingUp'))
              }, null, 8, ["disabled"]),
              _createVNode(_component_Button, {
                disabled: !_ctx.userEmail || !_ctx.userPassword || _ctx.userActionButton,
                type: "submit",
                "button-text": 'Continuar',
                "has-icon": 'Yes-Right',
                "icon-name": 'PhArrowCircleRight',
                "icon-size": 24,
                "icon-weight": 'Regular'
              }, null, 8, ["disabled"])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showView === 'EmailSingUp')
      ? (_openBlock(), _createElementBlock("main", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("form", {
            class: "emailCredentials",
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emailSingUp && _ctx.emailSingUp(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                id: "name",
                type: "text",
                placeholder: "Seu nome...",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userName]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                placeholder: "email@exemplo.com",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userEmail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userEmail]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                id: "password",
                type: "password",
                placeholder: "********",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userPassword]
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                disabled: !_ctx.userEmail || !_ctx.userPassword || _ctx.userActionButton,
                type: "submit",
                "button-text": 'Criar conta',
                "has-icon": 'No'
              }, null, 8, ["disabled"])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showView === 'Anonymous')
      ? (_openBlock(), _createElementBlock("main", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _hoisted_25,
          _createVNode(_component_Button, {
            disabled: _ctx.userActionButton,
            "button-text": 'Continuar',
            "has-icon": 'No',
            onClick: _ctx.anonymousLogin
          }, null, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showView === 'Main')
      ? (_openBlock(), _createElementBlock("footer", _hoisted_26, [
          _createElementVNode("p", null, [
            _createTextVNode("Ao usar este aplicativo, você concorda com a "),
            _createVNode(_component_router_link, { to: {name:'pp'} }, {
              default: _withCtx(() => [
                _createTextVNode("política de privacidade")
              ]),
              _: 1
            }),
            _createTextVNode(".")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}